import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Heart } from "lucide-react";
import { EXPERIENCE, CREDENTIALS, VOLUNTEER } from "../../data";

export const Experience = () => {
  return (
    <section id="experience" data-testid="experience-section" className="py-24 lg:py-36">
      <div className="mx-auto max-w-7xl section-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="label-caps text-berry mb-4">Experience</p>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight text-navy leading-tight">
            A track record
            <br />
            built on precision
          </h2>

          <div className="mt-12 space-y-8">
            <div>
              <div className="flex items-center gap-2 text-navy mb-4">
                <GraduationCap size={18} className="text-berry" />
                <span className="label-caps">Education &amp; Credentials</span>
              </div>
              <ul className="space-y-4">
                {CREDENTIALS.map((c) => (
                  <li key={c.title} data-testid={`credential-${c.title}`} className="border-l-2 border-slate-200 pl-4">
                    <p className="text-sm font-medium text-navy leading-snug">{c.title}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{c.org} · {c.meta}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="flex items-center gap-2 text-navy mb-4">
                <Heart size={18} className="text-berry" />
                <span className="label-caps">Board &amp; Volunteer</span>
              </div>
              <ul className="space-y-4">
                {VOLUNTEER.map((v) => (
                  <li key={v.role} className="border-l-2 border-slate-200 pl-4">
                    <p className="text-sm font-medium text-navy leading-snug">{v.role}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{v.org} · {v.period}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="relative">
            <div className="absolute left-0 top-2 bottom-2 w-px bg-slate-200 hidden sm:block" />
            <div className="space-y-10">
              {EXPERIENCE.map((job, i) => (
                <motion.div
                  key={`${job.company}-${job.role}`}
                  data-testid={`experience-${i}`}
                  initial={{ opacity: 0, x: 24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
                  className="relative sm:pl-10"
                >
                  <span className="absolute left-[-5px] top-2 w-2.5 h-2.5 bg-berry rotate-45 hidden sm:block" />
                  <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-1">
                    <h3 className="font-serif text-2xl text-navy">{job.role}</h3>
                    <span className="text-xs text-slate-400 whitespace-nowrap">{job.period}</span>
                  </div>
                  <p className="text-berry text-sm font-medium mt-0.5">{job.company}</p>
                  <ul className="mt-4 space-y-2">
                    {job.points.map((p, j) => (
                      <li key={j} className="flex gap-3 text-sm text-slate-600 leading-relaxed">
                        <span className="mt-2 w-1 h-1 bg-slate-400 rounded-full shrink-0" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
